import styled from 'styled-components';

export const BlotterWrapper = styled.div`
  height: 100%;
  width: 100%;

  .ag-header-row,
  .ag-row {
    .ag-header-cell:first-child,
    .ag-cell:first-child {
      padding-left: ${({ theme }) => theme.spacing12}px;
    }
  }
`;
